import * as React from "react";
import { styled } from "@mui/system";
import MUIDialogContentText from "@mui/material/DialogContentText";
import {
  DialogContentTextProps as DialogContentTextPropsMUI,
  DialogContentTextTypeMap
} from "@mui/material/DialogContentText";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface DialogContentTextProps extends DialogContentTextPropsMUI {}

const DialogContentTextRoot = styled(MUIDialogContentText, {
  name: "DialogContentText",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiDialogContentText-root": {
    ...theme.typography["body"]
  }
}));

export const DialogContentText = React.forwardRef<
  HTMLSpanElement,
  DialogContentTextProps
>(function DialogContentText(props, ref) {
  return <DialogContentTextRoot {...props} ref={ref} />;
}) as OverridableComponent<DialogContentTextTypeMap<{}, "span">>;
